import type { ProductVariantAvailabilityStatus } from "@swo/shared";

export function getJsonLdAvailability(availability: ProductVariantAvailabilityStatus) {
  switch (availability.tag) {
    case "in-stock": {
      return "https://schema.org/InStock";
    }
    case "at-dealers-only": {
      return "https://schema.org/InStoreOnly";
    }
    case "discontinued": {
      return "https://schema.org/Discontinued";
    }
    case "not-yet-available-for-sale": {
      return "https://schema.org/PreOrder";
    }
    case "preorder": {
      return "https://schema.org/PreOrder";
    }
    case "out-of-stock": {
      return "https://schema.org/OutOfStock";
    }
    default: {
      const _: never = availability;

      return _;
    }
  }
}
